export const PRODUCT_TABS = {
  reviews: 'tab-0',
  description: 'tab-1',
  specification: 'tab-2',
  compatibility: 'tab-3',
  reasons: 'tab-4',
  emptyReviews: 'tab-5',
  security: 'tab-6',
};
